import React from 'react';

const SECTIONS = [
  {
    icon: '🏠',
    title: 'Dashboard',
    body: 'Your home view. See overdue items, what’s coming up in the next 30 days, an overview of activity, recent files, and the latest community messages — all in one place.',
  },
  {
    icon: '✅',
    title: 'Tasks',
    body: 'Plan and track the work. Create tasks, assign them to committee members, set due dates, and move them across the board (To Do → In Progress → Done).',
  },
  {
    icon: '📁',
    title: 'Files',
    body: 'Store and share documents. Upload files and organise them by category (Track Readiness, Strategy & Growth, Meeting Notes, Decisions & Minutes, and Other).',
  },
  {
    icon: '📅',
    title: 'Calendar',
    body: 'Keep track of key dates. Add milestones, meetings and decisions so nothing important is missed.',
  },
  {
    icon: '📋',
    title: 'Plan',
    body: 'The Club Development Plan — capture the vision and values, run a SWOT analysis, and organise strategy into themes the committee can work through together.',
  },
  {
    icon: '💬',
    title: 'Community',
    body: 'Imported WhatsApp chat and synced strategy emails, so relevant conversations sit alongside the rest of the club’s planning.',
  },
];

export default function UserGuide({ onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-2 sm:p-4">
      <div className="bg-surface-container-lowest rounded-lg sm:rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 flex items-center justify-between p-3 sm:p-6 border-b border-outline-variant gap-3 bg-surface-container-lowest">
          <h2 className="font-bold font-headline text-sm sm:text-lg">📖 User Guide</h2>
          <button
            onClick={onClose}
            aria-label="Close user guide"
            className="text-on-surface-variant hover:text-on-surface font-bold text-2xl flex-shrink-0"
          >
            ×
          </button>
        </div>

        <div className="p-3 sm:p-6 space-y-4">
          <p className="text-sm text-on-surface-variant">
            Welcome to the EGAC Strategy Hub — the committee’s shared space for planning the track
            readiness project and developing the club strategy. Here’s what each tab does:
          </p>

          <div className="space-y-3">
            {SECTIONS.map((section) => (
              <div key={section.title} className="card p-3 sm:p-4">
                <h3 className="text-base font-bold font-headline mb-1">
                  <span className="mr-2">{section.icon}</span>
                  {section.title}
                </h3>
                <p className="text-xs sm:text-sm text-on-surface">{section.body}</p>
              </div>
            ))}
          </div>

          <div className="bg-primary-fixed p-3 sm:p-4 rounded-lg">
            <p className="text-xs sm:text-sm text-on-primary-fixed">
              📌 New here? Start by creating a task, uploading a document, or adding a key date to
              the calendar.
            </p>
          </div>
        </div>

        <div className="sticky bottom-0 flex items-center justify-between gap-3 p-3 sm:p-6 border-t border-outline-variant bg-surface-container-lowest">
          <a
            href="/guide/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs sm:text-sm text-primary hover:underline"
          >
            Open the full guide →
          </a>
          <button onClick={onClose} className="btn-primary text-sm px-4 py-2">
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
